import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const getOrgsByInn = async (search) => {
  return await request.get(
    `/Docs/orgs_by_inn/${search}`,
    null,
    'При получении организаций произошла ошибка'
  );
};

const useOrgsByInn = () => {
  const mutation = useMutation(getOrgsByInn, {
    onSuccess: (data) => {},
  });

  return {
    getAsync: mutation.mutateAsync,
    isFetching: mutation.isLoading,
    data: mutation.data,
  };
};

export default useOrgsByInn;
